import { firestore } from "firebase";
import { getHyDryEventFromEventNumber, HyDryEvent, HyDryEventCategory, HyDryEventMessage } from "./HyDryEvent";
import { ComBoxType } from "./ComBox";

export interface HyDryEventLogNote {
  createdAt: firestore.Timestamp;
  createdByClientId: string;
  createdByUserId: string;
  createdByUserNickname: string;
  text: string;
}

export interface HyDryEventLog {
  id: string;
  eventNumber: number;
  event?: HyDryEvent;
  eventCategory: HyDryEventCategory;
  eventDate: firestore.Timestamp;
  createdAt: firestore.Timestamp;
  dryRunStartDate: firestore.Timestamp;
  dryRunActive: boolean;
  program: number;
  step: number;
  cycle: number;
  additionalData?: string;
  note?: HyDryEventLogNote;
  comBoxType?: ComBoxType;
}

export function createHyDryMessageFromHyDryLog(
  serialNumber: string, 
  log: HyDryEventLog
): HyDryEventMessage {
  return {
    serialNumber: serialNumber,
    eventCategory: log.eventCategory,
    event: getHyDryEventFromEventNumber(log.eventNumber),
    eventNumber: log.eventNumber,
    messageDate: log.eventDate.toDate(),
    wasRead: true,
    additionalData: log.additionalData
  }
}
